import { render, staticRenderFns } from "./CatalogMenuHeader.vue?vue&type=template&id=52e89687&scoped=true"
import script from "./CatalogMenuHeader.vue?vue&type=script&lang=js"
export * from "./CatalogMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./CatalogMenuHeader.vue?vue&type=style&index=0&id=52e89687&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e89687",
  null
  
)

export default component.exports